module.exports = __webpack_public_path__ + "img/personal-account.a6bca5ab.svg";